// The detail form mirrors whatever Zero last synced, so only fields the user
// actually changed may travel to Linear. Resending an untouched copy reverts a
// Linear edit that has not reached us yet.
export function changedLinearFields({
	nextTitle,
	nextDescription,
	currentTitle,
	currentDescription,
}: {
	nextTitle: string | null | undefined
	nextDescription: string | null | undefined
	currentTitle: string | null | undefined
	currentDescription: string | null | undefined
}): { title?: string; description?: string } {
	const patch: { title?: string; description?: string } = {}
	if ((nextTitle ?? "") !== (currentTitle ?? "")) {
		patch.title = nextTitle ?? ""
	}
	if ((nextDescription ?? "") !== (currentDescription ?? "")) {
		patch.description = nextDescription ?? ""
	}
	return patch
}
